import $http from '@vue-util/http';
import constants from '../utils/constants';
import { fccZoneRecommendation } from '../data/processor/fccZone';

/**
 * Constructs the URL for the FCC recommendations server request.
 * @param {string|number} argCategoryId - The category ID for the request.
 * @param {string} sortingOrder - The sorting order for the request.
 * @param {Object} request - The request object.
 * @returns {string} The URL for the server request.
 */
export const fccUrl = (argCategoryId, sortingOrder, request) => {
  let categoryId = argCategoryId;
  if (
    request?.zone === constants.CAT_SPLASH_PAGE.C2FLEX_ZONE_A
    && request?.productId
  ) {
    categoryId = request.productId;
  }
  if (!categoryId || categoryId === -9 || categoryId === '-9') {
    categoryId = constants.DEFAULT_FCC_CATEGORY_ID;
  }
  return `${constants.PATH_FCC_RECOMMENDATIONS.replace(
    /CATEGORY_ID/,
    categoryId,
  )}&_sortby=${sortingOrder ?? 'BEST_SELLERS'}`;
};

/**
 * Retrieves FCC recommendations from the server.
 * @param {Object} request - The request object.
 * @param {Object} [properties={}] - The properties object.
 * @param {Object} [rtoResponse={}] - The RTO response object.
 * @returns {Promise<Object>} A promise that resolves to the FCC recommendations.
 * @throws {Error} If the request object is missing or invalid.
 */
const getFccRecommendations = async (
  request,
  properties = {},
  rtoResponse = {},
) => {
  if (!request?.zone) {
    throw new Error(
      `Recommendation getFccRecommendations parameters are not correct: ${request}`,
    );
  }
  const url = fccUrl(request.categoryId, properties.fccSortOrder, request);
  const headerDict = {
    timeout: request.timeout,
    dataType: 'json',
    headers: {
      'X-Macys-ClientId': 'PROS',
    },
  };

  const { data, status } = await $http.get(url, headerDict);
  if (status !== 200) {
    throw new Error(
      `FCC recommendation failed with status ${status}: ${request}`,
    );
  }

  return fccZoneRecommendation(data, request, properties, rtoResponse);
};

export default getFccRecommendations;
